/**
 * ColumnsElement — F12.H T12.H.3.
 *
 * Kolumny — siatka z N kolumnami (1-6), każde dziecko zajmuje jedną
 * kolumnę. Różni się od RowElement tym, że kolumny mają **stałą
 * szerokość** (1/N) zamiast elastycznego flex.
 *
 * Settings: { columns?: 1|2|3|4|5|6, gap?: 'sm'|'md'|'lg' }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const COLS_CLASS: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
};

const GAP_CLASS: Record<string, string> = {
  sm: 'gap-2',
  md: 'gap-3',
  lg: 'gap-4',
};

export const ColumnsElement: LayoutElementDefinition = {
  type: 'columns',
  category: 'kontenery',
  isContainer: true,
  label: 'Kolumny',
  icon: 'Columns3',
  defaultSettings: () => ({
    columns: 2,
    gap: 'md',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      columns?: number;
      gap?: 'sm' | 'md' | 'lg';
    };
    const n = Math.max(1, Math.min(6, settings.columns ?? 2));
    const colsCls = COLS_CLASS[n] ?? 'grid-cols-2';
    const gapCls = GAP_CLASS[settings.gap ?? 'md'] ?? 'gap-3';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`grid ${colsCls} ${gapCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition rounded p-1' : ''}`}
        data-testid={`columns-element-${element.id}`}
        data-element-type="columns"
        data-columns={n}
      >
        {children.length > 0
          ? children
          : isBuilder
            ? Array.from({ length: n }).map((_, idx) => (
                <div
                  key={idx}
                  className="rounded border-2 border-dashed border-border-primary py-3 text-center text-xs text-text-muted"
                >
                  Kolumna {idx + 1}
                </div>
              ))
            : null}
      </div>
    );
  },
};
